import { useQuery } from '@rocicorp/zero/react'
import { createFileRoute, notFound } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader'
import { ImplementationPage } from '#features/implementations/implementation-page.tsx'
import { TaskNotFound } from '#features/implementations/task.not-found.tsx'
import { getAppZero } from '#features/zero/app-zero-instance.ts'
import { queries } from '#zero/queries.ts'

export const Route = createFileRoute('/_app/$workspace/_dashboard/tasks/$id')({
  head: () => ({
    meta: [{ title: 'Task' }],
  }),
  // Runs on link hover (`defaultPreload: 'intent'`) and on navigation: warms
  // the exact detail query and releases the handle — the TTL keeps it syncing
  // so the page's useQuery attaches to an already-warm query.
  loader: ({ params }) => {
    getAppZero()
      ?.preload(queries.implementations.byId({ id: params.id }), { ttl: '5m' })
      .cleanup()
  },
  component: RouteComponent,
  notFoundComponent: TaskNotFound,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const params = Route.useParams()
  const [implementation, result] = useQuery(
    queries.implementations.byId({ id: params.id }),
  )

  // Target this route explicitly so the 404 renders via `TaskNotFound`
  // inside the dashboard shell instead of bubbling to the root boundary.
  if (implementation === undefined && result.type === 'complete') {
    throw notFound({ routeId: Route.id })
  }

  return (
    <>
      <title>{implementation?.title ?? 'Task'}</title>
      <ImplementationPage
        key={params.id}
        params={params}
        implementationId={params.id}
      />
    </>
  )
}
